import React from 'react';
import { initials } from '../../utils/enterpriseUi';

export default function EntPerson({ name, email, meta }) {
  return (
    <div className="ent-person">
      <span className="ent-avatar" aria-hidden="true">
        {initials(name || email)}
      </span>
      <span className="ent-person-text">
        <span className="ent-person-name">{name || '—'}</span>
        {email ? <span className="ent-person-email">{email}</span> : null}
        {meta ? <span className="ent-person-meta">{meta}</span> : null}
      </span>
    </div>
  );
}
